import { writable, get } from 'svelte/store';
import { NODE_CATALOG, fetchNodeCatalog, type NodeTypeDef } from './automations-api';

/**
 * Каталог node-типів. Seeded хардкодженим NODE_CATALOG (працює до fetch),
 * далі замінюється повним каталогом з бекенду (генерується з Node SDK), щоб
 * палітра/інспектор/рендер нод бачили всі ноди без ручної синхронізації.
 */
export const nodeCatalog = writable<Record<string, NodeTypeDef>>({ ...NODE_CATALOG });

let loaded = false;

export async function loadNodeCatalog(force = false): Promise<void> {
  if (loaded && !force) return;
  try {
    const items = await fetchNodeCatalog();
    const map: Record<string, NodeTypeDef> = {};
    for (const it of items) map[it.type] = it;
    nodeCatalog.set(map);
    loaded = true;
  } catch {
    // лишаємо seed-каталог
  }
}

export function catalogEntry(type: string): NodeTypeDef | undefined {
  return get(nodeCatalog)[type];
}
